import { render, staticRenderFns } from "./listUsp.vue?vue&type=template&id=82fd151a&"
import script from "./listUsp.vue?vue&type=script&lang=js&"
export * from "./listUsp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports